const SERVICE_DATA = {
    heading: "Areas of Practice",
    description: "We assist our clients in a variety of practice areas including the firm’s core areas of comprehensive litigation services before State and Federal Courts and Administrative Agencies.",
    services_list: [
        {
            label: "Civil Litigation",
            text: "If you're involved in a civil dispute, various legal avenues are available to resolve the matter. NJ State and federal laws concerning these issues can be complex, and navigating them alone can be frustrating. At Maite M. Matos Law, our attorneys have decades of experience to help you navigate the civil litigation process.",
            icon: "pe-7s-news-paper"
        },

        {
            label: "Personal Injury",
            text: "We specialize in the representation of plaintiffs in personal injury actions. Our vast experience in this area guides clients from the claims stage throughout the litigation process in both federal and state courts. We have a comprehensive practice which focuses on the individual needs of our clients.",
            icon: "pe-7s-attention" 
        },
        {
            label: "Business Sale/Aquisitions",
            text: "Our attorneys can guide you through every stage of the deal, from initial agreements to closing. We stay in close communication with our clients at each stage to ensure that practical and logistical considerations remain on track while we negotiate and draft the necessary documents to define each party's commitments.",
            icon: "pe-7s-paper-plane"
        },        
        {
            label: "Immigration",
            text: "Our immigration law attorneys handle family-based immigration matters.  We assist U.S. citizens, legal U.S. residents, immigrants and refugees who are seeking reunification with their family members or loved ones to secure family-based immigrant or fiancé visas. We also represent U.S. permanent residents seeking naturalization.",
            icon: "pe-7s-global"
        },
        {
            label: "DWI Defense",
            text: "New Jersey laws regarding drunk driving (DWI, DUI) are among the strictest in the nation, It is absolutely crucial to have an experienced N.J. DWI defense attorney represents you if you have been charged with driving while impaired or related drunk driving offenses in New Jersey. The criminal defense attorneys at Maite M. Matos Law have the courtroom-tested legal experience needed to defend you against DWI charges and seek the best possible outcome for your case.",
            icon: "pe-7s-car" 
        },
        {
            label: "Municipal Court",
            text: "The Law Offices of Maite M. Matos team of attorneys includes former prosecutors and public defenders with decades of experience in New Jersey municipal courts, as well as higher courts.  f you or a loved one have been arrested or ticketed in New Jersey and ordered to appear in municipal court, call us. Our attorneys can step in promptly to protect your rights.",
            icon: "pe-7s-culture"
        },
    ]
};


const TEAM_DATA = {
        title: 'About Us',
        description: 'We assist our clients in a variety of practice areas including the firm’s core areas of comprehensive litigation services before State and Federal Courts and Administrative Agencies.',
        team_list: [
            {
                profile: '/images/maite_matos.jpg',
                name: 'Maite M. Matos',
                designation: 'Attorney At Law',
                email: 'maite@mmatoslaw.com',
                bio: 'Maite Matos (formally Martinez-Gaeta) graduated from Rutgers College at Rutgers University and received her Juris Doctor from Benjamin N. Cardozo School of Law.  She was a law clerk to the Hon. Nestor Guzman, J.S.C. Criminal Part.  She worked at a law firm for over seven years where she gained experience in a wide range of fields.  Thereafter, she worked for County and Municipal Government for the next ten years and always focused on Litigation because her preference is always to be in a courtroom.  She currently maintains the position of Assistant Corporation Counsel for the City of Paterson where she is also Municipal Court Prosecutor.  There, she has handled most if not all DWI matters during the last three years.  She is also Chief Prosecutor for the Township of Montclair and often substitutes prosecutes in municipalities through Essex and Passaic Counties.  She hopes to bring her experience in Passaic and Essex to Morris County.  Her philosophy is to take an aggressive but practical approach to providing legal services of the highest quality while focusing on the needs of her clients.'
            },
            {
                profile: '/images/Iman_Boukadoum2.jpg',
                name: 'Iman Boukadoum',
                designation: 'Attorney At Law',
                email: 'iman@mmatoslaw.com',
                bio: 'Iman Boukadoum Esq. is an immigration and family law expert. She specializes in asylum and family unification cases. She graduated with distinction from the University of Virginia and received her J.D. from the College of William and Mary School of Law. She is fluent in Arabic and French.',
            },            
        ]
}

const MOCK_DATA = {
    SERVICE_DATA,
    TEAM_DATA
}

export default MOCK_DATA;